var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',{attrs:{"type":"text"},on:{"click":_vm.openEnclosureDialog}},[_vm._v(" "+_vm._s(_vm._column.files)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }